<template>

    <div>
        <div class="row">
            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'home'}">{{$t("inicio")}}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'configuracion-carta'}">{{$t('configuracionCarta')}}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'materias-primas-carta'}">{{$t('materiasPrimasCarta')}}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">{{action}} {{$t('materiaPrimaCarta')}}</li>
                    </ol>
                </nav>
            </div>
            <div class="col-md-12">
                <div class="card">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="form-group">
                                <label for="nombreProducto"><strong>{{$t('nombre')}}</strong> <span
                                        class="text-danger">*</span></label>
                                <input type="text" class="form-control"
                                       id="nombreProducto"
                                       v-model="materiaPrima.nombre">
                            </div>
                        </div>

                        <div class="col-md-4">
                            <div class="form-group">
                                <label><strong>{{$t('referenciaMateriasPrimasTpv')}}</strong> <span
                                        style="color: red">*</span></label>
                                <el-select
                                        class="select-default"
                                        v-model="materiaPrima.idSubproduct"
                                        filterable
                                        remote
                                        reserve-keyword
                                        :remote-method="searchMateriasPrimas"
                                        :placeholder="$t('nombreDeLaMateriaPrimaEnElTpv')">
                                    <el-option
                                            v-for="s in listMateriasPrimas"
                                            :key="s.id"
                                            :label="s.name"
                                            :value="s.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>

                        <div class="col-md-12">
                            <div class="form-group">
                                <label>
                                    <strong>{{$t("baja")}}</strong>
                                </label>
                                <el-switch v-model="materiaPrima.baja"
                                           active-color="#13ce66"
                                           inactive-color="#bcbcbc">
                                </el-switch>

                            </div>
                        </div>

                        <div class="col-md-12">
                            <div class="form-group">
                                <label>
                                    <strong>{{$t('disponible')}}</strong>
                                </label>
                                <el-switch v-model="materiaPrima.noDisponible"
                                           active-color="#13ce66"
                                           inactive-color="#bcbcbc">
                                </el-switch>

                            </div>
                        </div>

                        <div class="col-md-12">
                            <button class="btn btn-primary" @click="saveMateriasPrimas()"><i
                                    class="fa fa-check-square"></i> {{$t("guardar")}}
                            </button>
                            <router-link :to="{name:'materias-primas-carta'}">
                                <button class="btn btn-danger"><i class="fa fa-window-close"></i> {{$t("cancelar")}}
                                </button>
                            </router-link>

                            <el-checkbox v-model="checkReply" border class="checkbox-element">
                                {{$t("replicar")}}
                            </el-checkbox>
                        </div>

                    </div>
                </div>
            </div>
        </div>


        <modal name="modalReply" :adaptive=true :scrollable=true height="auto" :clickToClose=false>
            <div>
                <div class="modal-header">
                    <h4 style="margin: 0px">{{$t('replicarMateriaPrima')}}</h4>
                </div>
                <div class="modal-body">
                    <input type="checkbox" id="checkSelectAll" name="checkSelectAll" v-model="checkSelectAll"
                           @click="selectAll">
                    <label for="checkSelectAll" class="checkSelectAll">{{$t("seleccionarTodos")}}</label>

                    <div v-for="business in listBusinesses">
                        <el-checkbox v-if="business.id != idBusiness" v-model="business.checked" border
                                     class="checkbox-element" style="width: 100%">
                            {{business.establishmentName}}
                        </el-checkbox>
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-default" @click="$modal.hide('modalReply')"><i
                    class="fa fa-times-circle"></i> {{$t("cancelar")}}
                    </button>
                    <button class="btn btn-primary" @click="replyMateriasPrimas()"><i class="fa fa-check-circle"></i>
                    {{$t("aceptar")}}
                    </button>
                </div>
            </div>
        </modal>

    </div>

</template>

<script>
    import {
        DatePicker,
        Select,
        Option,
        Dropdown,
        DropdownItem,
        DropdownMenu,
        Button,
        Switch,
        CheckboxButton,
        CheckboxGroup,
        Checkbox
    } from 'element-ui'
    import {Loading} from 'element-ui';
    import swal from 'sweetalert2'
    import moment from 'moment'

    export default {
        name: "MateriaPrimaCarta",
        components: {
            [DatePicker.name]: DatePicker,
            [Select.name]: Select,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [Button.name]: Button,
            [Option.name]: Option,
            [Switch.name]: Switch,
            [Checkbox.name]: Checkbox,
            [CheckboxGroup.name]: CheckboxGroup,
            [CheckboxButton.name]: CheckboxButton
        },
        data() {
            return {
                idMateriaPrima: this.$route.params.idMateriaPrima,
                idBusiness: this.$route.params.idBusiness,

                materiaPrima: {
                    id: 0,
                    nombre: "",
                    idSubproduct: "",
                    noDisponible: true,
                    baja: false,
                    nameMateriaPrimaRef: "",
                },

                listMateriasPrimas: [],

                //REPLICAR
                checkReply: false,
                checkSelectAll: false,
                listBusinesses: [],

            }
        },
        created() {

            this.action = this.idMateriaPrima ? this.$i18n.t("editar") : this.$i18n.t("nuevo");

            if (this.idMateriaPrima) {


                this.getMateriaPrimaCarta();
            }

        },

        methods: {

            getMateriaPrimaCarta() {

                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        jwt: this.$store.getters.jwt,
                        idMateriaPrima: this.idMateriaPrima
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.$store.dispatch("setIdBusiness", this.idBusiness);
                this.axios.get(this.$store.getters.apiUrl + "delivery/getMateriaPrimaById", config)
                    .then(function (response) {
                        if (response.data.response) {

                            vm.materiaPrima = response.data.result;
                            vm.materiaPrima.xname=vm.materiaPrima.nombre;
                            vm.searchMateriasPrimas(vm.materiaPrima.nameMateriaPrimaRef);
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });


            },

            saveMateriasPrimas() {

                if (this.checkCampSubproduct()) {

                    var config = {
                        params: {
                            jwt: this.$store.getters.jwt,

                        },
                        headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                    };
                    var params = {
                        idBusiness: this.idBusiness,
                        materiaPrima: this.materiaPrima,
                        jwt: this.$store.getters.jwt,
                        idCarta: this.idCarta,
                    };

                    let vm = this;
                    let controller = this.idMateriaPrima ? "editarMateriaPrimaCarta" : "saveMateriaPrimaCarta";
                    this.axios.post(this.$store.getters.apiUrl + 'delivery/' + controller, params, config)
                        .then(function (response) {

                            console.log(response);

                            if (response.data.response) {


                                let notify = vm.$t("editada");
                                vm.$notify({
                                    message: vm.$t('materiaPrima')+' ' + notify + ' '+ vm.$t('correctamente'),
                                    icon: 'nc-icon nc-check-2',
                                    timeout: 2000,
                                    horizontalAlign: 'right',
                                    verticalAlign: 'top',
                                    type: 'success'
                                });

                                if (vm.checkReply) {

                                    vm.axios.get(vm.$store.getters.apiUrl + 'general/getBusinessesByUserReplicado', config)
                                        .then(function (response) {
                                            if (response.data.response) {
                                                vm.listBusinesses = response.data.result;
                                                vm.$modal.show('modalReply');
                                            } else {
                                                swal({
                                                    title: vm.$t('atencion'),
                                                    text: response.data.message,
                                                    confirmButtonClass: 'btn btn-info btn-fill',
                                                    type: 'error'
                                                });
                                            }

                                        });

                                } else {

                                    vm.$router.push({
                                        name: 'materias-primas-carta',
                                        params: {idBusiness: vm.idBusiness}
                                    })
                                }


                            } else {
                                swal({
                                    title: vm.$t('atencion'),
                                    text: response.data.message,
                                    confirmButtonClass: 'btn btn-info btn-fill',
                                    type: 'error'
                                });
                            }
                        }).catch(function (error) {
                        console.log(error);
                        vm.inProgress = false;
                    });


                }


            },

            checkCampSubproduct() {

                var check = true;

                if (this.materiaPrima.nombre === "") {

                    swal({
                        title: vm.$t('atencion'),
                        text: vm.$t('relleneLosCamposObligatorios'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                    check = false;
                }

                return check;


            },


            searchMateriasPrimas(query) {
                if (query !== '') {
                    const controller = 'searchMateriasPrimasTpv';
                    var config = {
                        params: {
                            idBusiness: this.idBusiness,
                            jwt: this.$store.getters.jwt,
                            query: query
                        },
                        headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                    };

                    let vm = this;
                    this.axios.get(this.$store.getters.apiUrl + "delivery/" + controller, config)
                        .then(function (response) {
                            if (response.data.response) {
                                vm.listMateriasPrimas = response.data.result.materiasPrimas;
                            }
                            else {
                                swal({
                                    title: vm.$t('atencion'),
                                    text: response.data.message,
                                    confirmButtonClass: 'btn btn-info btn-fill',
                                    type: 'error'
                                });
                            }
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                }
            },

            selectAll() {
                if (this.checkSelectAll) {
                    this.listBusinesses.forEach(function (business) {
                        business.checked = false;
                    });
                } else {
                    this.listBusinesses.forEach(function (business) {
                        business.checked = true;
                    });
                }
            },

            replyMateriasPrimas(){

                var listBuinessReply= this.listBusinesses.filter(bussines => bussines.checked);

                var config = {
                    params:{
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };


                let vm = this;
                var params = {
                    idBusiness: this.idBusiness,
                    listBusinesses: listBuinessReply,
                    materiaPrima:this.materiaPrima,
                    jwt: this.$store.getters.jwt
                };
                this.axios.post(this.$store.getters.apiUrl + 'delivery/replyAllSubproducts', params, config)
                    .then(function (response) {

                        vm.$modal.hide("modalReply");

                        vm.$router.push({
                            name: 'materias-primas-carta',
                            params: {idBusiness: vm.idBusiness}
                        })


                    }).catch(function (error) {
                    console.log(error);
                    vm.inProgress = false;
                });

            },

        }
    }
</script>

<style scoped>

    .card {
        padding: 20px;
    }


</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Delivery/Configuracion/MateriasPrimas/MateriaPrimaCarta.vue